import cloneDeep from 'lodash/cloneDeep';
import getIntegrations from './getIntegrations.json';

export default {
  getIntegrations() {
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(cloneDeep(getIntegrations));
      }, 500);
    });
  },
};
